module.exports = __webpack_public_path__ + "img/oufu_115x140x12b.prt.ff786f0a.jpg";